import { Dialogs } from 'dspx-core';

import {
  OPTION_SETS as SERVICE_WORKER_OPTION_SETS,
  OPTION_SET_NAMES as SERVICE_WORKER_OPTION_SET_NAMES,
  SAVE_RESULT_STATUS as SERVICE_WORKER_SAVE_RESULT_STATUS,
  NAV_TAB_NUMBERS as SERVICE_WORKER_NAV_TAB_NUMBERS,
  PAGE_NUMBERS as SERVICE_WORKER_PAGE_NUMBERS,
  SECTION_CODES as SERVICE_WORKER_SECTION_CODES,
  QUESTION_CODES as SERVICE_WORKER_QUESTION_CODES,
  QUESTION_PATHS as SERVICE_WORKER_QUESTION_PATHS,
  APPLICATION_ROLES as SERVICE_WORKER_APPLICATION_ROLES,
  UiDateFormat as SERVICE_WORKER_UiDateFormat,
  UiDateTimeFormat as SERVICE_WORKER_UiDateTimeFormat,
  FORM_IDENTIFIERS as SERVICE_WORKER_FORM_IDENTIFIERS,
  FORM_DUMMY_IDS as SERVICE_WORKER_FORM_DUMMY_IDS,
  DASHBOARD_EVENT as SERVICE_WORKER_DASHBOARD_EVENT,
  DASHBOARD as SERVICE_WORKER_DASHBOARD,
  FILTER as SERVICE_WORKER_FILTER
} from '../../../../ServiceWorker/src/constants/app-data.constants';

// This is used to open a dialog from the callback of another dialog being closed.
// Unfortunately there is no reliable way to wait for the dialog to close.
export const minWaitForDialogToCloseMs = 200;
export const minWaitForButtonClickToCompleteMs = 200;

export const defaultAppointmentHour = 7; // 7 AM

export const HeaderComponentSelector = 'dspx-card-set-header';
export const HeaderComponentClasses = ['topbar-left', 'topbar-right'];
export const PopupSelector = 'dspx-dialog';
export const BreadcrumbSelector = 'dspx-breadcrumb';
export const AppSelector = 'app-root';
export const SpinnerSelector = 'span.spinner-ui';

export const NotAssessedQuestionKeySuffix = '-notassessed';
export const RowSelectionLimit = 20;

export const SimplePopupValidationHeader = 'Validation Error';
export const OkButtonText = 'OK';

// This is the millisecond timeout for the spinner to start displaying the overlay.
// It matches the value set in the DSPX framework.
// Since that value is not exposed by DSPX, it needs to be redefined here.
export const SpinnerDisplayTimeoutMs = 100;

//MaatNcq
export const DefaultNonConformanceAmount = 0;

//MaatJob
export const NoAccessRuleKey = 'NoAccessRuleKey';

export class REPORT_TYPES {
  static readonly BusinessProgress = 'BusinessProgress';
  static readonly InvoicingSummary = 'InvoicingSummary';
}

export class BREADCRUMBS {
  static readonly separatorIcon = 'pi pi-angle-right';
  static readonly pageHeadings = {
    auditPlans: 'Audit Plans'
  } as const
}

export class APPLICATION {
  static readonly title = 'Inspection & Audit Portal';
  static readonly logo = '/assets/images/sgv-logo.png';
};

export enum APPLICATION_STATUS {
  ONLINE,
  ONLINE_AND_SYNC_IN_PROGRESS,
  ONLINE_AND_SYNC_REQUIRED,
  OFFLINE
};

export const APPLICATION_SUB_TITLE: Record<APPLICATION_STATUS, string> = {
  [APPLICATION_STATUS.ONLINE]: ' ', // Needs to be non-empty to have a non-zero size in the DOM
  [APPLICATION_STATUS.ONLINE_AND_SYNC_IN_PROGRESS]: 'SYNCING...',
  [APPLICATION_STATUS.ONLINE_AND_SYNC_REQUIRED]: 'SYNC REQUIRED',
  [APPLICATION_STATUS.OFFLINE]: 'OFFLINE'
};

export const APPLICATION_HEADER_BACKGROUND_COLOUR: Record<APPLICATION_STATUS, string> = {
  [APPLICATION_STATUS.ONLINE]: '', // It means that we use whatever is the default colour
  [APPLICATION_STATUS.ONLINE_AND_SYNC_IN_PROGRESS]: 'teal',
  [APPLICATION_STATUS.ONLINE_AND_SYNC_REQUIRED]: 'maroon',
  [APPLICATION_STATUS.OFFLINE]: 'grey'
};
  
export class APP_DATA_KEYS {
  static readonly previousModel = 'previousModel';
  static readonly logLevel = 'logLevel';
  static readonly serverAppSettings = 'serverAppSettings';
  static readonly hiipComplianceOfficerId = 'hiipComplianceOfficerId';
  static readonly loggedInUserRoleFlags = 'loggedInUserRoleFlags';
  static readonly publicHolidayDates = 'publicHolidayDates';
  static readonly maatSorDescriptionSet = 'maatSorDescriptionSet';
  static readonly position = 'position';
};

export class CUSTOM_FIELD_TYPE {
  static readonly cardSetPageWithCollapsibleSections = 'card-set-page-with-collapsible-sections';
  static readonly cardSectionCollapsible = 'card-section-collapsible';
  static readonly cardSectionRepeatingCollapsible = 'card-section-repeating-collapsible';
}

export const ComponentSelectors = {
  inspectionListForm: {
    inspectionList: 'app-inspection-list'
  },
  reportListForm:{
    reportList:'app-report-list'
  }
} as const;

export const ButtonTitle = {
  inspectionListForm: {
    getSelectedItems: 'Get selected items'
  }  
}

export class FORM_ACTIONS {
};

export class FORM_CUSTOM_ACTIONS {
  static readonly inspectionListGridDataType = {
    addAppointment: 'addAppointment',
    generateLetter: 'generateLetter',
    assignInspection: 'assignInspection',
    unassignInspection: 'unassignInspection',
    downloadInspectionLetters: 'downloadInspectionLetters',
    selectTopTwenty: 'selectTopTwenty',
    returnToDefaultView: 'returnToDefaultView'
  } as const;  
};

export class NOTIFICATION_CODES {
  static readonly common = {
    saveSuccessful: 'saveSuccessful'
  } as const;

  static readonly inspection = {
    saveSuccessNotification: 'saveSuccessNotification'
  } as const;

  static readonly inspectionList = {
    saveSuccessNotification: 'saveSuccessNotification'
  }
};

export class POP_UP_CODES {
  static readonly common = {
    clientError: Dialogs.CLIENT_ERROR,
    serverError: Dialogs.SERVER_ERROR,
    validationError: Dialogs.VALIDATION,
    saveSuccessful: 'saveSuccessful',
    saveForbidden: 'saveForbidden',
    confirmDocumentDeletion: 'confirmDocumentDeletion'
  } as const;

  static readonly maatJobList = {
    requestDocumentationConfirmation: 'requestDocumentationConfirmation',
    requestDocumentationSuccessful: 'requestDocumentationSuccessful',
    requestDocumentationMissingComplianceOfficerDetails: 'requestDocumentationMissingComplianceOfficerDetails',
    requestDocumentationMissingContractorDetails: 'requestDocumentationMissingContractorDetails',
    submitDocumentationConfirmation: 'submitDocumentationConfirmation',
    submitDocumentationSuccessful: 'submitDocumentationSuccessful',
    submitDocumentationMissingFiles: 'submitDocumentationMissingFiles',
    referToSeniorProjectOfficerIneligibleNcqsStatus: 'referToSeniorProjectOfficerIneligibleNcqsStatus',
    referToSeniorProjectOfficerConfirmation: 'referToSeniorProjectOfficerConfirmation',
    referToSeniorProjectOfficerSuccessful: 'referToSeniorProjectOfficerSuccessful',
    referToManagerIneligibleNcqsStatus: 'referToManagerIneligibleNcqsStatus',
    referToManagerConfirmation: 'referToManagerConfirmation',
    referToManagerSuccessful: 'referToManagerSuccessful',
    returnToProjectOfficerConfirmation: 'returnToProjectOfficerConfirmation',
    returnToProjectOfficerSuccessful: 'returnToProjectOfficerSuccessful',
    completeAuditPlanIneligibleNcqsStatus: 'completeAuditPlanIneligibleNcqsStatus',
    completeAuditPlanConfirmation: 'completeAuditPlanConfirmation',
    completeAuditPlanSuccessful: 'completeAuditPlanSuccessful',
    returnToSeniorProjectOfficerConfirmation: 'returnToSeniorProjectOfficerConfirmation',
    returnToSeniorProjectOfficerSuccessful: 'returnToSeniorProjectOfficerSuccessful',
    finaliseAuditPlanConfirmation: 'finaliseAuditPlanConfirmation',
    finaliseAuditPlanSuccessful: 'finaliseAuditPlanSuccessful',
    undoCompleteAuditPlanConfirmation: 'undoCompleteAuditPlanConfirmation',
    undoCompleteAuditPlanSuccessful: 'undoCompleteAuditPlanSuccessful',
    setInspectionDate: 'setInspectionDate',
    setInspectionDateSuccess: 'setInspectionDateSuccess',
    setInspectionDateFailureUpdateIsNotAllowed: 'setInspectionDateFailureUpdateIsNotAllowed',
    issueNcqBulkSuccess: 'issueNcqBulkSuccess',
    issueNcsqBulk: 'issueNcsqBulk',
    reIssueReferredNcsqBulk: 'reIssueReferredNcsqBulk',
    issueNcqBulkIsNotAllowed: 'issueNcqBulkIsNotAllowed',
    noNcqsToIssue: 'noNcqsToIssue',
    noNcqsToReIssue: 'noNcqsToReIssue',
    bulkIssueNcqMissingComplianceOfficerDetails: 'bulkIssueNcqMissingComplianceOfficerDetails',
    bulkIssueNcqMissingContractorDetails: 'bulkIssueNcqMissingContractorDetails'
  } as const;

  static readonly maatJobItemList = {
    noAccessFlagged: 'noAccessFlagged',
    noAccessUnflagged: 'noAccessUnflagged',
    saveFailureInspectionDateUpdateIsNotAllowed: 'saveFailureInspectionDateUpdateIsNotAllowed'
  } as const;

  static readonly maatNcq = {
    confirmDocumentation: 'confirmDocumentation',
    confirmContractorDocumentation: 'confirmContractorDocumentation',
    confirmSeniorProjectOfficerDocumentation: 'confirmSeniorProjectOfficerDocumentation',
    deleteNcqConfirmation: 'deleteNcqConfirmation',
    deleteNcqSuccessful: 'deleteNcqSuccessful'
  } as const;

  static readonly maatUser = {
    duplicateHiipComplianceOfficer: 'duplicateHiipComplianceOfficer',
    duplicateHiipContractor: 'duplicateHiipContractor'
  } as const;

  static readonly maatSorDescriptionList = {
    deleteConfirmation: 'deleteConfirmation',
    deleteSuccessful: 'deleteSuccessful'
  } as const;

  static readonly maatSorDescription = {
    duplicateSorCode: 'duplicateSorCode',
    deleteConfirmation: 'deleteConfirmation',
    deleteSuccessful: 'deleteSuccessful'
  } as const;

  static readonly organisation = {
    organisationWithSameNameAlreadyExists: 'organisationWithSameNameAlreadyExists',
    duplicateAreaAndStartDateAcrossOrganisations: 'duplicateAreaAndStartDateAcrossOrganisations',
    duplicateAreaInSameOrganisation: 'duplicateAreaInSameOrganisation',
    areaStartDateLessThanOrganisationStart: 'areaStartDateLessThanOrganisationStart',
    areaEndDateMoreThanOrganisationEnd: 'areaEndDateMoreThanOrganisationEnd'
  } as const;

  static readonly team = {
    teamWithSameNameAlreadyExists: 'teamWithSameNameAlreadyExists'
  } as const;

  static readonly user = {
    userWithSameEmailAlreadyExists: 'userWithSameEmailAlreadyExists',
    invalidOrganisationForPasUserOrPasManager: 'invalidOrganisationForPasUserOrPasManager'
  } as const;

  static readonly inspectionList = {
    addAppointment: 'addAppointment',
    addAppointmentResult: 'addAppointmentResult',
    addAppointmentBulk: 'addAppointmentBulk',
    addAppointmentBulkResult: 'addAppointmentBulkResult',
    modifyAppointment: 'modifyAppointment',
    modifyAppointmentResult: 'modifyAppointmentResult',
    cancelAppointment: 'cancelAppointment',
    cancelAppointmentResult: 'cancelAppointmentResult',
    viewNoAccessDetails: 'viewNoAccessDetails',
    viewNoAccessDetailsForQA: 'viewNoAccessDetailsForQA',
    acceptInspectionResult: 'acceptInspectionResult',
    rejectInspectionResult: 'rejectInspectionResult',
    rejectInspectionByQAResult: 'rejectInspectionByQAResult',
    generateLetterBulkResult: 'generateLetterBulkResult',
    assignInspectionBulk: 'assignInspectionBulk',
    assignInspectionBulkResult: 'assignInspectionBulkResult',
    unassignInspectionBulkResult: 'unassignInspectionBulkResult',
    noInspectionSelected: 'noInspectionSelected',
    fileDownloadError: 'fileDownloadError',
    propertySummary: 'propertySummary',
    startInspectionView: 'startInspectionView',
    noAccessNotAllowed: 'noAccessNotAllowed',
    updateInspectionStatus: 'updateInspectionStatus'
  } as const;

  static readonly inspection = {
    addManagerFeedback: 'addManagerFeedback',
    addDepartmentFeedback: 'addDepartmentFeedback',
    viewInspectionFeedback: 'viewInspectionFeedback',
    reAssignInspector: 'reAssignInspector',
    savedElsewhere: 'savedElsewhere',
    saveInspectionError: 'saveInspectionError',
    successfulInspectionReject: 'successfulInspectionReject',
    successfulInspectionApprove: 'successfulInspectionApprove'
  } as const;

  static readonly syncEntityList = {
    entityDetails: 'entityDetails',
    discardEntityConfirmation: 'discardEntityConfirmation',
    exportDiagnosticsSuccess: 'exportDiagnosticsSuccess',
    exportDiagnosticsPartialSuccess: 'exportDiagnosticsPartialSuccess',
    exportDiagnosticsFailure: 'exportDiagnosticsFailure'
  } as const;

  static readonly inspectionCalendar = {
    modifyCalendarAppointment: 'modifyCalendarAppointment',
    modifyCalendarAppointmentResult: 'modifyCalendarAppointmentResult'
  } as const;

  static readonly batchList = {
    successfulInspectionBatchApprove: 'successfulInspectionBatchApprove',
    successfulInspectionBatchReject: 'successfulInspectionBatchReject',
    saveInspectionBatchError: 'saveInspectionBatchError',
    noInspectionsToApproveError: 'noInspectionsToApproveError'
  } as const;

  static readonly resultPopupMessageKey = 'resultPopupMessage';
};

export class POP_UP_TEXTS {
  static readonly common = {
    confirmDocumentDeletion: '<p>Confirm the deletion of this document?</p>'
  } as const;

  static readonly maatNcq = {
    duplicateNcqId: 'The NCQ Number already exists for this job item.</br>Please choose a different NCQ Number.',
    invalidDateRaised: 'Date Raised must be between the Audit Plan start date and today.',
    categoryIsMandatory: 'Please enter the Category.',
    nonConformanceAmountIsMandatory: 'Please enter the Non Conformance Amount.',
    totalItemCostPercentageIsMandatory: 'Please enter the Total Item Cost Percentage.',
    descriptionIsMandatory: 'Please enter the Description.',
    actionProposedIsMandatory: 'Please enter the Action Proposed.',
    tradeCodeIsMandatory: 'Please enter the Trade Code.',
    contractorPositionIsMandatory: 'Please enter the Contractor Position.',
    causesConsequencesIsMandatory: 'Please enter the Causes/Consequences.',
    proposedActionIsMandatory: 'Please enter the Proposed Action.',
    preventativeMeasuresIsMandatory: 'Please enter the Preventative Measures.',
    hcNonConformanceAmountIsMandatory: 'Please enter the Non Conformance Amount.',
    contractorLegalAcceptanceIsMandatory: 'Please certify the legal compliance.',
    businessPositionProjectOfficerRecommendationIsMandatory: 'Please enter the Business Position.',
    projectOfficerRecommendationIsMandatory: 'Please enter the Project Officer Recommendation.',
    reInspectFeeIsMandatory: 'Please enter the Re-Inspect Fee.',
    projectOfficerRecommendationLastUpdatedByIsInvalid: 'Project Officer Recommendation Last Updated By is invalid.',
    projectOfficerRecommendationLastUpdatedDateIsInvalid: 'Project Officer Recommendation Last Updated Date is invalid.',
    seniorProjectOfficerQueryAndCommentsIsMandatory: 'Please enter the Senior Project Officer Query / Comments.',
    actionIsMandatory: 'Please enter the Action.',
    contractorAdditionalInfoResponseIsMandatory: "Please enter the Contractor's Response.",
    contractorAdditionalInfoLastUpdatedByIsInvalid: 'Contractor Response Last Updated By is invalid.',
    contractorAdditionalInfoLastUpdatedPositionIsInvalid: 'Contractor Response Last Updated Position is invalid.',
    contractorAdditionalInfoLastUpdatedDateIsInvalid: 'Contractor Response Last Updated Date is invalid.',
    seniorProjectOfficerRecommendationIsMandatory: 'Please enter the Senior Project Officer Recommendation.',
    seniorProjectOfficerRecommendationLastUpdatedUserNameIsInvalid: 'Senior Project Officer Recommendation Last Updated By is invalid.',
    seniorProjectOfficerRecommendationUpdatedUserDateIsInvalid: 'Senior Project Officer Recommendation Last Updated Date is invalid.',
    businessPositionIsMandatory: 'Please enter the Business Position.',
    managerTradeCodeIsMandatory: 'Please enter the Trade Code.',
    managerCategoryIsMandatory: 'Please enter the Category.',
    managerDeterminationIsMandatory: 'Please enter the Manager Determination.',
    managerNonConformanceAmountIsMandatory: 'Please enter the Non Conformance Amount.',
    managerLastUpdatedUserNameIsInvalid: 'Manager Last Updated By is invalid.',
    managerLastUpdatedUserDateIsInvalid: 'Manager Last Updated Date is invalid.',
    issueNcqMissingComplianceOfficerDetails: 'The audit plan does not include a compliance officer, or the compliance officer’s contact details are missing.',
    issueNcqMissingContractorDetails: 'The audit plan does not include a contractor, or the contractor contact details are missing.'
  } as const;
};

export class POP_UP_STYLE_CLASS {
  static readonly dialogXl: 'dialog-xl'
};

export { SERVICE_WORKER_OPTION_SETS as OPTION_SETS };

export { SERVICE_WORKER_OPTION_SET_NAMES as OPTION_SET_NAMES };

export { SERVICE_WORKER_SAVE_RESULT_STATUS as SAVE_RESULT_STATUS };

export class SERVER_ERROR_POP_UP_CODES {
  static readonly addAppointment = [
    // No error popup codes have been defined
  ];

  static readonly saveMaatAuditPlan = [
    POP_UP_CODES.maatJobList.requestDocumentationMissingComplianceOfficerDetails,
    POP_UP_CODES.maatJobList.requestDocumentationMissingContractorDetails,
    POP_UP_CODES.maatJobList.submitDocumentationMissingFiles
  ];

  static readonly setMaatJobInspectionDate = [
    POP_UP_CODES.maatJobList.setInspectionDateFailureUpdateIsNotAllowed
  ];

  static readonly saveMaatJob = [
    POP_UP_CODES.maatJobItemList.saveFailureInspectionDateUpdateIsNotAllowed
  ];

  static readonly bulkIssueNcqs = [
    POP_UP_CODES.maatJobList.issueNcqBulkIsNotAllowed,
    POP_UP_CODES.maatJobList.noNcqsToIssue,
    POP_UP_CODES.maatJobList.noNcqsToReIssue,
    POP_UP_CODES.maatJobList.bulkIssueNcqMissingComplianceOfficerDetails,
    POP_UP_CODES.maatJobList.bulkIssueNcqMissingContractorDetails
  ];

  static readonly saveMaatUser = [
    POP_UP_CODES.maatUser.duplicateHiipComplianceOfficer,
    POP_UP_CODES.maatUser.duplicateHiipContractor,
  ];

  static readonly saveMaatSorDescription = [
    POP_UP_CODES.maatSorDescription.duplicateSorCode
  ];

  static readonly saveOrganisation = [
    POP_UP_CODES.organisation.organisationWithSameNameAlreadyExists,
    POP_UP_CODES.organisation.duplicateAreaAndStartDateAcrossOrganisations,
    POP_UP_CODES.organisation.duplicateAreaInSameOrganisation,
    POP_UP_CODES.organisation.areaStartDateLessThanOrganisationStart,
    POP_UP_CODES.organisation.areaEndDateMoreThanOrganisationEnd,
  ];

  static readonly saveTeam = [
    POP_UP_CODES.team.teamWithSameNameAlreadyExists
  ];

  static readonly saveUser = [
    POP_UP_CODES.user.userWithSameEmailAlreadyExists,
    POP_UP_CODES.user.invalidOrganisationForPasUserOrPasManager
  ];

  static readonly saveInspection = [
    // No error popup codes have been defined
  ];
};

export { SERVICE_WORKER_NAV_TAB_NUMBERS as NAV_TAB_NUMBERS };

export { SERVICE_WORKER_PAGE_NUMBERS as PAGE_NUMBERS };

export { SERVICE_WORKER_SECTION_CODES as SECTION_CODES };

export { SERVICE_WORKER_QUESTION_CODES as QUESTION_CODES };

export { SERVICE_WORKER_QUESTION_PATHS as QUESTION_PATHS };

export { SERVICE_WORKER_APPLICATION_ROLES as APPLICATION_ROLES };

export class PAGE_ACTION_BUTTON_CODES {
  static readonly maatJobList = {
    cancel: 'btnCustomCancel',
    summaryReport: 'btnSummaryReport',
    submitDocumentation: 'btnSubmitDocumentation'
  } as const;
  static readonly maatJobItemList = {
    cancel: 'btnCustomCancel'
  } as const;
  static readonly maatNcqList = {
    cancel: 'btnCustomCancel'
  } as const;
  static readonly maatNcq = {
    cancel: 'btnCustomCancel',
    deleteNcq: 'btnDeleteNcq'
  } as const;
  static readonly maatUser = {
    cancel: 'btnCustomCancel'
  } as const;
  static readonly inspection = {
    btnFeedback: 'btnFeedback',
    btnAccept: 'btnAccept',
    btnReject: 'btnReject'
  } as const;
};

export const READ_ONLY_ACCESS_PAGE_ACTION_BUTTONS: { [form: string]: string[] } = {
  maatJobList: [
    PAGE_ACTION_BUTTON_CODES.maatJobList.cancel,
    PAGE_ACTION_BUTTON_CODES.maatJobList.summaryReport,
    PAGE_ACTION_BUTTON_CODES.maatJobList.submitDocumentation
  ],
  maatJobItemList: [
    PAGE_ACTION_BUTTON_CODES.maatJobItemList.cancel
  ],
  maatNcqList: [
    PAGE_ACTION_BUTTON_CODES.maatNcqList.cancel
  ],
  maatNcq: [
    PAGE_ACTION_BUTTON_CODES.maatNcq.cancel,
    PAGE_ACTION_BUTTON_CODES.maatNcq.deleteNcq
  ],
  maatUser: [
    PAGE_ACTION_BUTTON_CODES.maatUser.cancel
  ],
  inspection: [
    PAGE_ACTION_BUTTON_CODES.inspection.btnFeedback,
    PAGE_ACTION_BUTTON_CODES.inspection.btnAccept,
    PAGE_ACTION_BUTTON_CODES.inspection.btnReject
  ]
};

export { SERVICE_WORKER_UiDateFormat as UiDateFormat };
export { SERVICE_WORKER_UiDateTimeFormat as UiDateTimeFormat };
export const SettingDateFormat = 'dd/MM/yyyy';

export { SERVICE_WORKER_FORM_IDENTIFIERS as FORM_IDENTIFIERS };
export { SERVICE_WORKER_FORM_DUMMY_IDS as FORM_DUMMY_IDS };
export { SERVICE_WORKER_DASHBOARD_EVENT as DASHBOARD_EVENT };
export { SERVICE_WORKER_DASHBOARD as DASHBOARD }
export { SERVICE_WORKER_FILTER as FILTER };

export class COLLAPSIBLE_SECTION_TIMING {
  /**
   * Delay (ms) to wait after collapsing a section before applying values.
   * This allows the section to fully collapse and DOM elements to be removed
   * before re-initialization.
   */
  static readonly collapseWaitMs = 100;

  /**
   * Delay (ms) to wait after expanding a section for file upload components to initialize.
   * File upload components require additional time to mount and register their form controls
   * before values can be properly set.
   */
  static readonly expandWaitMs = 200;
}
